import * as React from "react";

import { Link } from "react-router-dom";

export const AlreadyHaveAccountLink = () => (
  <div className="w-full text-base leading-tight">
    <span className="text-content-secondary">
      Already have a Replo account?{" "}
    </span>
    <Link to="/auth/login" className="text-primary hover:underline">
      Sign in
    </Link>
  </div>
);
